<template>
    <better-link class="link d-flex align-items-center small-site-tile" :to="permalink(tileData)">
        <div 
            class="featured-image mr-3" 
            :style="`background-image:url(${tileData.photos.length 
                ? tileData.photos[0].permalink + '?w=800' 
                : '//drench.imgix.net/media/drench-site-no-image.jpg?w=800'});`"
        ></div>
        <div class="media-body">
            <h5 class="my-0">{{ tileData.name }}</h5>
            <h6 class="my-0" v-if="tileData.location && tileData.location.formatted_locality">{{ tileData.location.formatted_locality }}</h6>
        </div>
    </better-link>
</template>

<script>
export default {
    name: 'SmallSiteTile',
    props: {
        tileData: {
          type: Object,
          required: true,
        }
    },
    methods: {
        permalink(tile) {
            return '/sites/'+tile.slug
        },
    },
};
</script>

<style lang="scss">
.small-site-tile {
    padding: 10px;
    border-radius: 8px;
    border: 1px solid transparent;
    color: $darkest-gray;
    
    &:hover {
        text-decoration: none;
        background: $off-white;
        border: 1px solid $lightest-gray;
    }
    .featured-image {
        width: 60px;
        height: 60px;
        border-radius: 8px;
        border: 1px solid $lighter-gray;
        background-size: cover;
        background-position: center;
    }
}
</style>


